import { EmptyIcon } from "@adapters/presenters/action-interfaces/Reports/HoldingReport";
export const enterMail = "Please Enter email.";
export const validMail = "Please Enter valid email address.";
export enum ReportsEnum {
  HOLDINGS = "holdings",
  POSITIONS = "positions",
  PNL = "Profit and Loss",
  TXN = "transactions",
  TAX = "tax",
  DP = "dp transactions",
  SUBSCRIPTION = "Subscription",
  ACCOUNTOVERVIEW = "AccountOverview",
  LEDGER = "ledger",
  DPC = "Delayed Payment Interest",
  DPBILL = "DPBILL",
  CONTRACTNOTES = "Contract notes",
  HOLDING_REVAMP = "holding_revamp",
  POSITION_REVAMP = "position_revamp",
}
export const EmptyValidation = {
  [EmptyIcon.EMPTY]: {
    [ReportsEnum.HOLDINGS]: {
      icon: "edel-icon-emtpy_icon",
      message: `You don't have any ${ReportsEnum.HOLDINGS}.`,
    },
    [ReportsEnum.DP]: {
      icon: "edel-icon-reports-note",
      message: `You don't have any ${ReportsEnum.DP}.`,
    },
    [ReportsEnum.DPBILL]: {
      icon: "edel-icon-reports-note",
      message: `No results found! `,
    },
    [ReportsEnum.DPC]: {
      icon: "edel-icon-reports-note",
      message: `No results found! `,
    },
    [ReportsEnum.POSITIONS]: {
      icon: "edel-icon-emtpy_icon",
      message: `You don't have any ${ReportsEnum.POSITIONS}.`,
    },
    [ReportsEnum.PNL]: {
      icon: "edel-icon-emtpy_icon",
      message: `No records are available for the <br/> entered period, try a new period.`,
    },
    [ReportsEnum.TAX]: {
      icon: "edel-icon-emtpy_icon",
      message: `No records are available for the <br/> entered period, try a new period.`,
    },
    [ReportsEnum.TXN]: {
      icon: "edel-icon-emtpy_icon",
      message: `No records are available for the <br/> entered period, try a new period.`,
    },
    [ReportsEnum.SUBSCRIPTION]: {
      icon: "edel-icon-reports-note",
      message: `No results found! `,
    },
    [ReportsEnum.CONTRACTNOTES]: {
      icon: "edel-icon-reports-note",
      message: `No results found! `,
    },
    [ReportsEnum.ACCOUNTOVERVIEW]: {
      icon: "edel-icon-emtpy_icon",
      message: `No records are available for the <br/> entered period, try a new period.`,
    },
    [ReportsEnum.LEDGER]: {
      icon: "edel-icon-reports-note path1",
      message: `No results found! <br/>
      Try searching for something else`,
    },
    [ReportsEnum.HOLDING_REVAMP]: {
      icon: "edel-icon-no-holdings",
      message: `You don’t have any holdings<br/> Try searching for something else`,
    },
    [ReportsEnum.POSITION_REVAMP]: {
      icon: "edel-icon-reports-note",
      message: `No results found! <br/>
      Try searching for something else`,
    },
  },
  [EmptyIcon.SEARCH]: {
    icon: "edel-icon-wentwrong-search",
    message: "There are no entries matching your search criteria.",
  },
  [EmptyIcon.SEARCH_NEW]: {
    icon: "edel-icon-wentwrong-search",
    message: "Couldn’t find anything! <br/> Try searching for something else",
  },
  [EmptyIcon.FILTER]: {
    icon: EmptyIcon.FILTER,
    message: "There are no entries matching your filter criteria.",
  },
  default: "No Data available",
  noOpenOrder: "Seems like there are no open orders in your order book.",
  noClosedOrder: "Seems like there are no closed orders in your order book.",
  noNcdOrder: "Seems like there are no NCD IPO orders in your order book.",
  noIpoOrder: "Seems like there are no IPO orders in your order book.",
  noOfsOrder: "Seems like there are no OFS orders in your order book.",
  noSipOrder: "Seems like there are no ESIP orders in your order book.",
  [EmptyIcon.ERROR]: {
    icon: "edel-icon-emtpy_icon",
    message: "Something went wrong! Please try after sometime.",
  },
  [EmptyIcon.ERROR_EXCLA]: {
    icon: "edel-icon-report-excla",
    message: `No results found! <br/>
      Try searching for something else`,
  },
};
export const aifDesclaimer = "Face Value is considered in Price for AIF.";
export const pnlTablemessage =
  "Quantity in PnL report is post doing adjustment of corporate action on Ex Date. Actual impact in Demat Holding might take longer time. Hence, there might be difference in quantity as per Pnl and Holding Report.";
